import { LABELS, formatDateBR, type DueRule, type NotificationType, type PolicyScope } from '@orienta/shared';

export const notificationLabel = (t: string) => LABELS.notificationType[t as NotificationType] ?? t;


export const SCOPE_LABEL: Record<PolicyScope, string> = {
  GLOBAL: 'Global',
  INSTITUTION: 'Instituição',
  PROGRAM: 'Programa',
  MODALITY: 'Modalidade',
  WORK: 'Exceção de trabalho',
};

const UNIT: Record<string, string> = { days: 'dia(s)', weeks: 'semana(s)', months: 'mês(es)' };
/** Origem de uma regra resolvida (inclui o padrão do sistema). */
export const SOURCE_SCOPE_LABEL: Record<string, string> = {
  DEFAULT: 'Padrão do sistema',
  GLOBAL: 'Global',
  INSTITUTION: 'Instituição',
  PROGRAM: 'Programa',
  MODALITY: 'Modalidade',
  WORK: 'Exceção do trabalho',
};

export function describeDue(due: DueRule): string {
  if (due.type === 'absolute') return formatDateBR(due.date);
  const anchor = due.anchor === 'work.start' ? 'início' : due.anchor === 'work.end' ? 'término previsto' : `"${due.anchor.slice('checkpoint:'.length)}"`;
  const sign = due.offset >= 0 ? '+' : '−';
  return `${anchor} ${sign} ${Math.abs(due.offset)} ${UNIT[due.unit] ?? due.unit}`;
}

export function formatRuleValue(v: unknown): string {
  if (typeof v === 'boolean') return v ? 'Sim' : 'Não';
  if (Array.isArray(v)) return v.join(', ');
  return String(v);
}

const AUDIT_ACTIONS: Record<string, string> = {
  'work.create': 'Trabalho criado',
  'work.update': 'Trabalho atualizado',
  'work.change_status': 'Situação alterada',
  'work.archive': 'Trabalho arquivado',
  'work.unarchive': 'Trabalho desarquivado',
  'work.participant_add': 'Participante incluído',
  'work.participant_remove': 'Participante removido',
  'work.transfer_lead': 'Orientação principal transferida',
  'work.policy_exception': 'Exceção de política registrada',
  'work.policy_migrate': 'Migração de política aplicada',
  'checkpoint.status': 'Estado de checkpoint alterado',
  'checkpoint.add': 'Checkpoint adicionado',
  'extension.request': 'Prorrogação solicitada',
  'extension.approve': 'Prorrogação aprovada',
  'extension.reject': 'Prorrogação rejeitada',
  'task.create_draft': 'Tarefa criada (rascunho)',
  'task.create_published': 'Tarefa criada e publicada',
  'task.publish': 'Tarefa publicada',
  'task.update': 'Tarefa editada',
  'task.archive': 'Tarefa arquivada',
  'task.declare': 'Tarefa declarada pelo(a) estudante',
  'task.confirm': 'Tarefa confirmada',
  'task.request_changes': 'Ajuste solicitado em tarefa',
  'task.reschedule': 'Prazo de tarefa alterado',
  'deliverable.create': 'Entrega esperada criada',
  'deliverable.submit': 'Versão de entrega enviada',
  'deliverable.approve': 'Entrega aprovada',
  'deliverable.request_changes': 'Ajustes solicitados na entrega',
  'deliverable.archive': 'Entrega arquivada',
  'file.upload': 'Arquivo enviado',
  'file.download': 'Arquivo baixado',
  'file.view': 'Arquivo visualizado',
  'feedback.create': 'Comentário registrado',
  'checkin.submit': 'Check-in enviado',
  'checkin.review': 'Check-in revisado',
  'meeting.create': 'Reunião agendada',
  'meeting.update': 'Reunião atualizada',
  'meeting.publish_minutes': 'Ata publicada',
  'request.create': 'Solicitação aberta',
  'request.accept': 'Solicitação aceita',
  'request.reject': 'Solicitação recusada',
  'request.withdraw': 'Solicitação retirada',
  'invitation.create': 'Convite criado',
  'invitation.accept': 'Convite aceito',
  'report.request': 'Relatório solicitado',
  'report.download': 'Relatório baixado',
  'ai.request': 'Análise de IA solicitada',
  'ai.suggestion_accepted': 'Sugestão de IA aceita',
  'ai.suggestion_edited': 'Sugestão de IA editada',
  'ai.suggestion_rejected': 'Sugestão de IA rejeitada',
  'ai.suggestion_publish': 'Sugestão de IA publicada',
};

export function auditActionLabel(action: string): string {
  return AUDIT_ACTIONS[action] ?? action;
}
